<!-- src/components/dashboard/tasks/TaskCardSection.vue
  FT-076: секция задач для карточек. Пустой список скрыт — создание идёт из шапки.
  v-show сохраняет автономную загрузку TaskList без initial-пропов.
  FT-223: ошибка начальной секции оставляет видимым существующий snackbar. -->
<template>
  <div v-show="taskableId && !initialState.hidden && (hasTasks || initialState.error)" class="task-card-section">
    <task-list :taskable-type="taskableType" :taskable-id="taskableId"
               :initial-section="initialSection" :initial-users-section="initialUsersSection"
               :initial-entity-id="initialEntityId" @initial-state="initialState = $event" />
    <v-divider class="mt-3" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TaskList from "./TaskList.vue";

export default {
  name: "TaskCardSection",
  components: { TaskList },
  props: {
    taskableType: { type: String, required: true },
    taskableId: { type: [String, Number], default: null },
    initialSection: { type: Object, default: undefined },
    initialUsersSection: { type: Object, default: undefined },
    initialEntityId: { type: [String, Number], default: undefined },
  },
  data: () => ({ initialState: { hidden: false, error: false } }),
  computed: {
    ...mapState("tasks", { items: (s) => s.items }),
    hasTasks() { return this.items.length > 0; },
  },
};
</script>
